import { Alert, type AlertProps } from '@/components/ui/alert';
import { useTranslation } from 'react-i18next';

export const StripeConfigurationAlert = (
  props: Omit<AlertProps, 'children' | 'status' | 'title'>
) => {
  const { t } = useTranslation();

  return (
    <Alert status="error" title={t('payouts.checkout.stripeConfigurationMissing.title')} {...props}>
      {t('payouts.checkout.stripeConfigurationMissing.description')}
    </Alert>
  );
};
